import { observer } from "mobx-react-lite";
import * as React from "react";
import LocationForm from "../parent-flow/forms/LocationForm";
import { FormContainer } from "./components/FormWrapper";

const LessonLocationPage = observer(
  ({
    onSubmit,
    formInitialValues = {},
    locationSelectorVM,
    loading,
    defaultCountry,
    onBack,
    ...props
  }: any) => {
    const formCopy = {
      heading: "Where will lessons hold?",
      description:
        "Tell us if you want physical or online lessons, and also enter your location to help us find the best tutors close to you.",
    };
    const values = formInitialValues;
    if (defaultCountry) {
      formInitialValues.country = defaultCountry;
    }
    console.log(`Values are ${defaultCountry}`, values);
    return (
      <FormContainer key={defaultCountry} {...formCopy} {...props}>
        <LocationForm
          loading={loading}
          formInitialValues={{
            ...values,
            country: defaultCountry || values.country,
          }}
          defaultCountry={defaultCountry}
          locationSelectorVM={locationSelectorVM}
          onSubmitForm={onSubmit}
          onBack={onBack}
        />
      </FormContainer>
    );
  },
);

export default LessonLocationPage;
